import { useContext } from 'react';
import { PageContext } from '@/context/PageContext';
import { TranslatableField } from '@/types/supportedLanguages';

interface UseTranslatableField {
  translateField: (field?: TranslatableField, fallbackOverride?: string) => string;
}

let FALLBACK_LANGUAGE = 'en';

export const useTranslatableField = (locale?: string): UseTranslatableField => {
  const { survey } = useContext(PageContext);
  const translateField = (field?: TranslatableField, fallbackOverride?: string): string => {
    if (!field) return '';

    // if we are a survey load the surveys fallback language
    if (survey?.fallback_language) {
      FALLBACK_LANGUAGE = survey.fallback_language;
    }
    if (fallbackOverride) {
      FALLBACK_LANGUAGE = fallbackOverride;
    }
    const languageFallback = locale?.split('-')[0] || FALLBACK_LANGUAGE;

    const {
      [locale || FALLBACK_LANGUAGE]: selectedLocaleField,
      [languageFallback]: selectedLanguageField,
      [FALLBACK_LANGUAGE]: fallbackLanguageField,
    } = field;

    return selectedLocaleField || selectedLanguageField || fallbackLanguageField || '';
  };

  return {
    translateField,
  };
};
